const RoleEnum= {
       ADMIN: "Admin",
       MAINTAINER: "Maintainer",
       PARTNER: "Partner",
       ADVERTISER: "Advertiser",
       USER:  "User"
}

export default RoleEnum;